import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Typography, Button, CircularProgress } from '@mui/material';
import { PauseCircle, DeleteOutline } from '@mui/icons-material';

// Small confirm dialog in the same shape as Sidebar.js's LogoutDialog.
export default function GiftVoucherConfirmDialog({ open, tone = 'info', title, message, confirmLabel, onCancel, onConfirm }) {
  const [busy, setBusy] = useState(false);
  const danger = tone === 'danger';
  const handleConfirm = async () => {
    setBusy(true);
    try { await onConfirm(); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onClose={busy ? undefined : onCancel} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '12px', p: 0.5, m: { xs: 2, sm: 3 } } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pb: 1 }}>
        <Box sx={{ width: 36, height: 36, borderRadius: '10px', bgcolor: danger ? '#FEF2F2' : '#EEF2FF', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          {danger ? <DeleteOutline sx={{ fontSize: 20, color: '#EF4444' }} /> : <PauseCircle sx={{ fontSize: 20, color: '#4F46E5' }} />}
        </Box>
        <Typography fontWeight={800} fontSize="1rem" color="#1E293B">{title}</Typography>
      </DialogTitle>
      <DialogContent sx={{ pt: 0, pb: 1 }}>
        <Typography fontSize="0.875rem" color="#64748B">{message}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 2.5, pb: 2, gap: 1 }}>
        <Button onClick={onCancel} disabled={busy} variant="outlined" fullWidth
          sx={{ borderRadius: '8px', fontWeight: 700, textTransform: 'none', borderColor: '#E2E8F0', color: '#64748B', '&:hover': { bgcolor: '#F8FAFC', borderColor: '#CBD5E1' } }}>
          Cancel
        </Button>
        <Button onClick={handleConfirm} disabled={busy} variant="contained" fullWidth disableElevation
          sx={{ borderRadius: '8px', fontWeight: 700, textTransform: 'none', bgcolor: danger ? '#EF4444' : '#4F46E5', '&:hover': { bgcolor: danger ? '#DC2626' : '#4338CA' } }}>
          {busy ? <CircularProgress size={16} sx={{ color: '#fff' }} /> : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
